import * as React from 'react';
import SuperCritical from 'lib/supercritical';

export let BookingRateView = SuperCritical(({ bookingRate } : { bookingRate : () => number | null }) =>
    <div className="bookingrate">
        <div className="bookingrate-label pc-text-accent bookingtip">
            Booking Rate
            <span className="glyphicon glyphicon-info-sign"></span>
            <span className="bookingtiptext">
                The Booking Rate is the percentage of <span className="bold">Total Reservations </span>
                 during the last year that have an <span className="bold">Actual Arrival</span>.
                 Actual Arrivals are reservations where the First Line is logged as
                 <span className="italic"> actual</span>. A 100&#37; Booking Rate means every reservation
                 had an actual arrival. Cancellations lower the Booking Rate. If every reservation
                 was cancelled, the Booking Rate would be 0&#37;. Reservations without a First Line
                 Actual (no-shows or missing actuals) are not counted as Actual Arrivals.
                 They also lower the Booking Rate.
            </span>
        </div>
        <div className="percentage">
            {bookingRate() === null ? '--' : bookingRate() + '%'}
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/bookingrate/view.tsx